import { RadioChoicesModalComponent } from './radio-choices-modal.component';

export default angular
  .module('sfMobile.components.radio-choices-modal', [
    'sfMobile.components.button-header-close',
    'sfMobile.components.input-radio',
    'sfMobile.components.input-radio-free',
  ])
  .component('sfRadioChoicesModal', RadioChoicesModalComponent).name;
